import { object, string } from 'yup';

import { messages, trim } from '../../../../../data/utils/form.utils';

export const schema = object()
  .shape({
    startDate: string().transform(trim).nullable(),
    endDate: string()
      .transform(trim)
      .test(
        'end-date',
        messages.invalidEndDate.id,
        function endDateTest(value) {
          const { startDate } = this.parent;
          if (!startDate || !value) return true;
          return new Date(value) >= new Date(startDate);
        }
      )
      .nullable(),
  })
  .noUnknown();
